<div *ngIf="shareHolders$ | async as shareHolders">
  <p-panel header="Share Holders" styleClass="drill-down-section-header" [toggleable]="true">
    <div>
      <p-table [value]="shareHolders" styleClass="share-holders-table" [paginator]="true" [rows]="20" [alwaysShowPaginator]="false">
        <ng-template pTemplate="header">
          <tr class="share-holders-header-row">
            <th class="col-share-holders-name">Name</th>
            <th class="col-share-holders-id">ID</th>
            <th>Country</th>
            <th>Industry Codes</th>
            <th class="col-share-holders-type">Type</th>
            <th class="col-share-holders-percent">Direct %</th>
            <th class="col-share-holders-percent">Total %</th>
            <th>Oper Rev in million</th>
            <th>Total Assets in million</th>
            <th># of Empl.</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-shareHolder>
          <tr class="share-holder-row">
            <td>
              {{ shareHolder.name }}
            </td>
            <td>
              {{ shareHolder.id }}
            </td>
            <td>
              {{ shareHolder.country }}
            </td>
            <td>
              {{ shareHolder.industryCodes }}
            </td>
            <td>
              {{ shareHolder.type }}
            </td>
            <td>
              {{ shareHolder.directPercent }}
            </td>
            <td>
              {{ shareHolder.totalPercent }}
            </td>
            <td>
              {{ shareHolder.operatingRevenue }}
            </td>
            <td>
              {{ shareHolder.totalAssets }}
            </td>
            <td>
              {{ shareHolder.numberOfEmployees }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr class="share-holders-no-result">
            <td [attr.colspan]="10" class="text-center">No results to display</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-panel>
</div>
